import { Suspense, lazy, useEffect, useContext } from 'react';
import { useRoutes, useSearchParams } from "react-router-dom";
import SuspenseLoader from '../components/SuspenseLoader';
import SidebarLayout from '../layouts/SidebarLayout'
import PartnerContext from 'main/contexts/PartnerContext';

const Loader = (Component) => (props) => (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
);

const HomeViewPage = Loader(lazy(() => import('features/Home/presenter/pages/HomeView')));
const DocumentsPage = Loader(lazy(() => import('features/documents/presenter/pages/Documents')));
const VerifyOtpPage = Loader(lazy(() => import('features/otp/presenter/pages/VerifyCode')));
const ValidationIdentityPage = Loader(lazy(() => import('features/identity_validation/presenter/pages/ValidationIdentityPage')));
const SuccessProcessPage = Loader(lazy(() => import('features/identity_validation/presenter/pages/SuccessProcessPage')));
const VerificationFaceIdentityPage = Loader(lazy(() => import('features/identity_validation/presenter/pages/VerificationFaceIdentityPage')));
const ErrorPage = Loader(lazy(() => import('main/components/pages/Error')));
const RetractPage = Loader(lazy(() => import('main/components/pages/Retract')));
const SuccessPage = Loader(lazy(() => import('main/components/pages/Success')));

function RouteWrapper({ Component }) {
  const [searchParams] = useSearchParams();
  const guid = searchParams.get('guid');
  const status = searchParams.get('status');
  const { setPartner } = useContext(PartnerContext);

  //------------look and feel-------------
  const host = window.location.host
  let domain = host.split('.')[1]
  let subdomain = host.split('.')[0]
  if (domain === undefined && subdomain !== undefined) {
    domain = subdomain
    subdomain = undefined
  }
  let partnerName
  switch (domain) {
    case 'avistapp':
      partnerName = "avista";
      break;
    case 'linkalianza':
      partnerName = "linkAlianza";
      break;
    default:
      partnerName = "avista";
  }

  useEffect(() => {
    setPartner(partnerName || 'default');
  }, [partnerName, setPartner]);
  //------------end look and feel-------------

  return <Component guid={guid} status={status}/>;
}

const routes = [
  {
    path: "/",
    element: <SidebarLayout/>,
    children: [
      {
        path: "/",
        element: <RouteWrapper Component={HomeViewPage} />
      },
      // La ruta /approval ahora apunta a HomeViewPage
      { path: '/approval', element: <RouteWrapper Component={HomeViewPage} /> },
      { path: '/visualize', element: <RouteWrapper Component={HomeViewPage} /> },
      { path: '/documents', element: <RouteWrapper Component={DocumentsPage} /> },
      { path: '/verify-otp', element: <RouteWrapper Component={VerifyOtpPage} /> },
      { path: '/identity-validation/confirmation', element: <RouteWrapper Component={ValidationIdentityPage} /> },
      { path: '/identity-validation/success-process', element: <RouteWrapper Component={SuccessProcessPage} /> },
      { path: '/verification-identity', element: <RouteWrapper Component={VerificationFaceIdentityPage} /> },
      { path: '/verify', element: <RouteWrapper Component={VerificationFaceIdentityPage} /> },
      { path: '/error', element: <RouteWrapper Component={ErrorPage} /> },
      { path: '/cancel', element: <RouteWrapper Component={RetractPage} /> },
      { path: '/success', element: <RouteWrapper Component={SuccessPage} /> },
      { path: '*', element: <RouteWrapper Component={ErrorPage} /> },
    ]
  },
];

export default function Router() {
  return useRoutes(routes);
}
